import { NhlApp } from './schedule-picker';
import { mapDictionaryToArray, rankSort } from '../shared/helpers';

(window as any).SchedulePicker = (window as any).SchedulePicker ?? {};
(window as any).SchedulePicker.App = { mapDictionaryToArray, RankSort: rankSort };

document.addEventListener('DOMContentLoaded', () => {
  const app = new NhlApp();
  (window as any).SchedulePicker.App.convertPrimeTimeToShortString = app.convertPrimeTimeToShortString.bind(app);
  (window as any).SchedulePicker.App.convertPrimeTimeToString = app.convertPrimeTimeToString.bind(app);
  (window as any).SchedulePicker.App.convertPrimeTimeAndDateToString = app.convertPrimeTimeAndDateToString.bind(app);
  (window as any).vm = app;
  (window as any).__pp_debug = app;
});
